/* eslint-disable */
import convertList from '../convertList';
import { envDomain } from '@/common/contact-selector/utils/domainConfig'
import performanceReport from '@tencent/qd-lib/es/performanceReport';
let rootNodeId = undefined // 记录一个全局变量 也就是根节点的id，目前没其他地方可存

export default function (config) {

    let pageInfo = {
        index: 0,
        end: false
    }

    if (config.params === undefined) {
        config.params = {}
    }

    if (config.params && config.params.pageInfo) {
        pageInfo = config.params.pageInfo
    }


    const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    const moreConfig = {
        ...config,
        totalState: false
    };
    console.log('------->', config)
    if (selfConfig.ajax) {
        return new Promise((resolve, reject) => {
            getOrgTree().then(res => {
                if (res.code !== 0) {
                    reject("组织架构数据获取失败", res.code)
                }
                // 默认根节点数据是不要的，所以需要重新请一次
                if (res.data.deps.length === 0) return resolve([])
                let rootId = res.data.deps[0].id
                getOrgTree(rootId).then(res => {
                    let { deps, staffs } = res.data;
                    performanceReport.reportPcFirstScreen('[新]关系链选择器');
                    let groups = deps.map(x => {
                        return {
                            ...x,
                            list: [],
                            // memberTotal: 10
                        }
                    })

                    let users = staffs.map(x => {
                        return {
                            ...x,
                            colleagueInfo: {
                                account: x.account
                            },
                            id: x.kfext
                        }
                    })

                    let list = convertList(
                        [...groups, ...users],
                        {
                            list: 'list',
                            groupName: 'name',
                            total: 'employees_total'
                        },
                        moreConfig
                    )

                    resolve(list)
                })
            })
        })
    }

    let isBigOrg = false
    try {
        isBigOrg = config.extendConfig.colleague.isBigOrgApi
    } catch (error) {
        console.warn("undfined isBigOrgApi")
    }
    if (isBigOrg) {
        // 如果是大组织架构

        return new Promise((resolve, reject) => {
            // 说明从根节点开始加载的
            getBigOrgTreeFromJsapi('0', 1).then(res => {
                if (res.code !== 0) {
                    reject("组织架构数据获取失败", res.code)
                }
                // 默认根节点数据是不要的，所以需要重新请一次
                if (res.data.deps.length === 0) return resolve([])
                let rootId = res.data.deps[0].id
                config.params.rootNodeId = rootId

                getBigOrgTreeFromJsapiById(rootId, pageInfo, moreConfig).then(res2 => {
                    res2.params.rootNodeId = rootId;
                    resolve(res2)
                })
            })
        })
    }



    return new Promise((resolve, reject) => {
        let dataRange = 'all';
        try {
            dataRange = selfConfig.selectorConfig.config.dataRange || dataRange;
        } catch (err) {
            // no code
        }
        const data = {
            groupId: '0',
            dataRange
        };
        _getColleagueListById(data).then(
            res => {
                performanceReport.reportPcFirstScreen('[新]关系链选择器');
                if (res.data.list && res.data.list.length) {
                    resolve(
                        convertList(
                            res.data.list,
                            {
                                list: 'list',
                                groupName: 'name',
                                total: 'totalMember'
                            },
                            moreConfig
                        )
                    );
                } else {
                    resolve([]);
                }
            },
            err => {
                reject(err);
            }
        );
    });


}

function _getColleagueListById(data) {
    return new Promise((resolve, reject) => {
        qdp.getColleagueListById({
            groupId: data.groupId,
            dataRange: data.dataRange,
            success(res) {
                resolve(res);
            },
            fail(res) {
                reject(res);
            }
        });
    });
}


function getOrgTree(depId = "0") {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/v1/org/OrgTreeWithNum`, { depId, sub_dep_count: true });
}

function getBigOrgTreeFromJsapi(depId = 0, index = 1) {
    return new Promise((resolve, reject) => {
        console.log(`[JSAPI][getOrgTree][REQ][deptId:${depId}][pageIndex:${index}]`)
        qdp.getOrgTree({
            depId,
            index,
            visable: {
                filter_disabled: true
            },
            count: 20,
            success(res) {
                console.log("[JSAPI][getOrgTree][RSP]: ", res)
                res.code = 0
                resolve(res);
            },
            fail(res) {
                reject(res);
            }
        });
    });
}


function getBigOrgTreeFromJsapiById(id, pageInfo, moreConfig) {
    return new Promise((resolve, reject) => {
        getBigOrgTreeFromJsapi(id, (pageInfo.index + 1)).then(res => {
            let { deps, staffs, index, total_node, count } = res.data
            let groups = deps.map(x => {
                return {
                    ...x,
                    list: [],
                    uuid: x.id
                    // memberTotal: 10
                }
            })

            let users = staffs.map(x => {
                return {
                    ...x,
                    colleagueInfo: {
                        account: x.account
                    },
                    id: x.kfext
                }
            })

            moreConfig.transformGroup = function (item) {
                item.loaded = false
                return item
            }

            let list = convertList(
                [...users, ...groups],
                {
                    list: 'list',
                    groupName: 'name',
                    total: 'employees_total'
                },
                moreConfig
            )
            console.log(`[RSP][list]:`, list)

            pageInfo.index = index
            let end = true;
            if (total_node && index < total_node / count) {
                end = false;
            }
            pageInfo.end = end

            resolve({
                list,
                params: { pageInfo }
            })
        })
    })
}


